<template>
<div>
    <law-ledes-detail-form :getLawLedesDetailList="getLawLedesDetailList" ref="lawLedesDetailFormModal" :lawLedesId="this.lawLedesId"></law-ledes-detail-form>
    <law-ledes-excel-read-form :getLawLedesDetailList="getLawLedesDetailList" ref="lawLedesExcelReadFormModal" :lawLedesId="this.lawLedesId"></law-ledes-excel-read-form>
    <b-row>
        <b-col class="col-12">
            <div style="float:right;" class="custom-search d-flex justify-content-end">
                <b-form-group>
                    <div class="d-flex align-items-center">
                        <b-button style="float:right; border-color:#6B7280; color:#374151;" size="sm" variant="outline-secondary" @click="readExcel()">{{ $t('lawLedesDetail.add_from_excel') }}</b-button>
                    </div>
                </b-form-group>
                <b-form-group>
                    <div class="d-flex align-items-center">
                        <b-button style="float:right; border-color:#6B7280; color:#374151;" size="sm" variant="outline-secondary" @click="getInfo()">{{ $t('lawLedesDetail.add') }}</b-button>
                    </div>
                </b-form-group>
            </div>
        </b-col>
    </b-row>
    <!-- table -->
    <vue-good-table id="lawLedesDetailTable" ref="lawLedesDetailTable" :columns="columns" :rows="rows" styleClass="vgt-table condensed tableSize" :select-options="{
                enabled: false,
                selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                selectionInfoClass: 'custom-class',
                selectionText: 'rows selected',
                clearSelectionText: 'clear',
                disableSelectInfo: true, // disable the select info panel on top
                selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
              }" theme="my-theme">
        <div slot="emptystate">
            {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
            <span v-if="props.column.field === 'name'" class="text-nowrap">
                {{ $t('lawLedesDetail.name') }}
            </span>
            <span v-else-if="props.column.field === 'code'" class="text-nowrap">
                {{ $t('lawLedesDetail.code') }}
            </span>
            <span v-else-if="props.column.field === 'lawLedesCodeType'" class="text-nowrap">
                {{ $t('lawLedesDetail.lawLedes_code_type') }}
            </span>
            <span v-else-if="props.column.field === 'description'" class="text-nowrap">
                {{ $t('lawLedesDetail.description') }}
            </span>
            <span v-else-if="props.column.field === 'tmpt'" class="text-nowrap">
                {{ $t('lawLedesDetail.tmpt') }}
            </span>
            <span v-else-if="props.column.field === 'process'" class="text-nowrap"></span>
        </template>
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
            <!-- Column: Process -->
            <span v-if="props.column.field === 'description'">
                <div v-b-tooltip.hover="{ title: props.row.description, customClass: 'wh-tooltip' }" class="wh-clamp-2">{{ props.row.description }}</div>
            </span>
            <span v-else-if="props.column.field === 'name'">
                {{ props.row.name }}
            </span>
            <span v-else-if="props.column.field === 'code'">
                {{ props.row.code }}
            </span>
            <span v-else-if="props.column.field === 'lawLedesCodeType'">
                {{ props.row.lawLedesCodeType }}
            </span>
            <span v-else-if="props.column.field === 'tmpt'">
                {{ props.row.tmpt }}
            </span>
            <span v-else-if="props.column.field === 'process'">
                <list-actions-dropdown :actions="[
                    { icon: 'EditIcon', label: $t('others.edit'), handler: () => getInfo(props.row.id) },
                    { icon: 'XIcon', label: $t('others.delete'), color: '#DC2626', handler: () => deleted(props.row) }
                ]" />
            </span>
        </template>

        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ props.total }} {{ $t('dataTable.record') }} </span>
                    <b-form-select v-model="pageLength" :options="['10','50','100', '1000']" class="mx-1" @input="(value)=>props.perPageChanged({currentPerPage:value})" />
                    <span class="text-nowrap"> {{ $t('dataTable.row_is_show') }} </span>
                </div>
                <div>
                    <b-pagination :value="1" :total-rows="props.total" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" @input="(value)=>props.pageChanged({currentPage:value})">
                        <template #prev-text>
                            <feather-icon icon="ChevronLeftIcon" size="18" />
                        </template>
                        <template #next-text>
                            <feather-icon icon="ChevronRightIcon" size="18" />
                        </template>
                    </b-pagination>
                </div>
            </div>
        </template>
    </vue-good-table>
</div>
</template>

<script>
export default {
    props: {
        lawLedesId: Number,
    },
    data() {
        return {
            pageLength: 10,
            dir: false,
            columns: [{
                    label: this.$t('lawLedesDetail.name'),
                    field: `name`,
                },
                {
                    label: this.$t('lawLedesDetail.code'),
                    field: `code`,
                },
                {
                    label: this.$t('lawLedesDetail.lawLedes_code_type'),
                    field: `lawLedesCodeType`,
                },
                {
                    label: this.$t('lawLedesDetail.description'),
                    field: `description`,
                },
                {
                    label: this.$t('lawLedesDetail.tmpt'),
                    field: `tmpt`,
                },
                {
                    label: '',
                    field: 'process',
                    width: '8em',
                    sortable: false
                },
            ],
            rows: [],
            searchTerm: '',
        }
    },
    mounted() {
        this.getLawLedesDetailList()
    },
    methods: {
        async deleted(data) {
            data = {
                id: data.id
            }
            const controller = {
                name: 'LawLedesDetail'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$DeleteConfirm().then(result => {
                if (result.value) {
                    this.$store.dispatch('moduleAuth/delete', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$DeleteAlert()
                            this.getLawLedesDetailList()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                            this.getLawLedesDetailList()
                        }
                    })
                }
            })
        },
        async getInfo(id) {
            this.$refs.lawLedesDetailFormModal.showInfo(id, this.lawLedesId)
        },
        async readExcel() {
            this.$refs.lawLedesExcelReadFormModal.showInfo(this.lawLedesId)
        },
        getLawLedesDetailList() {
            this.rows = []
            const data = {
                id: this.lawLedesId
            }
            const controller = {
                name: 'LawLedesDetail',
                actionName: 'GetLawLedesDetailListByLawLedesId'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    response.data.lawLedesDetailList.forEach(element => {
                        this.rows.push(element)
                    })
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        exportExcel() {
            const controller = {
                name: 'LawLedesDetail',
                actionName: 'CanExport'
            }
            const data = {
                columnList: this.columns,
                DataList: this.rows
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.$downloadFile("FaturaGonderimTipi", response.data.base64, 'xlsx')
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        }
    },
}
</script>

<style lang="scss">
.excel-css {
    float: right;
    margin-right: 1em;
    width: 9.5em;
    color: #7367f0;
    border: 1px solid #7367f0;
    background-color: transparent;
    margin-left: 1em;
    height: 2em;
    border-radius: 0.358rem;
}

.tableSize {
    font-size: 13px !important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}
</style>
